import React from "react";
import { Box } from "rizzui/box";
import LinkedIn from "../assets/linkedIn";
import Google from "../assets/google";
import { Button } from "rizzui/button";
import { Text } from "rizzui/typography";
import { useNavigate } from "react-router";

export default function SocialLogin() {
  const navigate = useNavigate();
  const handleSocials = () => {
    //navigate("/account/completesignup");
  };

  return (
    <div className="mb-[32px] w-[231px] h-[76px] justify-self-center">
      <div className="flex flex-row justify-around mb-[16px]">
        <Button
          className="bg-foreground border border-[#D1D6DD] w-[87px] h-[40px] rounded-[54px] hover:bg-foreground"
          onClick={handleSocials}
        >
          <Google />
        </Button>

        <Button
          className="bg-foreground border border-[#D1D6DD] w-[87px] h-[40px] rounded-[54px] hover:bg-foreground"
          onClick={handleSocials}
        >
          <LinkedIn />
        </Button>
      </div>

      <div className="flex flex-row gap-[21px]">
        <Box className="h-[1px] self-center bg-[#D1D6DD] flex-1" />
        <Text className="text-[12px] font-[400]">OR</Text>
        <Box className="h-[1px] self-center bg-[#D1D6DD] flex-1" />
      </div>
    </div>
  );
}
